import { KeyboardAvoidingViewProps } from 'react-native';
import React from 'react';
import { DefaultTheme } from 'styled-components/native';
import { ConnectionStatusView } from '@/components/compose/connection.status.view';
import { AppKeyboardAvoidingView } from '@/components/compose/app.keyboard.avoding.view';

interface Props {
  backgroundColor?: keyof DefaultTheme['colors']['screen']['background'];
  children?: any;
  behavior?: KeyboardAvoidingViewProps['behavior'];
  connectionStatus?: boolean;
}
function BaseAppScreen({ connectionStatus = true, backgroundColor = 'white', behavior = 'padding', children }: Props) {
  return (
    <AppKeyboardAvoidingView behavior={behavior} backgroundColor={backgroundColor}>
      {connectionStatus && <ConnectionStatusView enabled={connectionStatus} />}
      {children}
    </AppKeyboardAvoidingView>
  );
}

export const AppScreen = React.memo(BaseAppScreen);
